import DataObjectsTemplate from "../../../../datasets/data_object_templates";
import addMasterInfo from "./add_master_info";

export const changeBuyTranToHistoryFormat = (tranArr, investMaster) => {

    let buyTransactionArr = [];
    let outputTranArr = [];
    for (let i=0; i<tranArr.length; i++){
        let transaction = tranArr[i];
        if (transaction.tranType === "buy"){
            let newTranObj = DataObjectsTemplate.find(elem => elem.dataType === "investHistoryTransaction");
            newTranObj.investShortName = transaction.investShortName;
            newTranObj.tranType = transaction.tranType;
            newTranObj.quantity = transaction.quantity;
            newTranObj.dateBought = transaction.transactionDate;
            newTranObj.dateClosed = transaction.transactionDate;
            newTranObj.buyPrice = transaction.unitPrice;
            newTranObj.buyAmount = (+transaction.quantity * +transaction.unitPrice).toFixed(2);
            newTranObj.sellPrice = 0;
            newTranObj.sellAmount = 0;
            newTranObj.totalGainLoss = 0;
            buyTransactionArr.push(newTranObj);
        }else{
            outputTranArr.push(transaction);
        }
    }
    let outputBuyTranArr = 
        addMasterInfo(buyTransactionArr, investMaster);
    outputTranArr = outputTranArr.concat(outputBuyTranArr);
    return outputTranArr;         
}
export default changeBuyTranToHistoryFormat;
